import { onMount } from 'solid-js';
import { Match, Switch } from 'solid-js';
import { css } from '@emotion/css';
import { calcHeight } from 'Shared/frontend/widgets/HeightUtils';

const iframeStyle = (height) => css({
	width: '100%',
	maxWidth: '100%',

	...calcHeight(height)
});


export function Embed(P)
{
	let node!: HTMLElement;

	/* Note: innerHTML doesn't run code, so using this instead. */
	onMount(() => {
		if (node) {
			const frag = document.createRange().createContextualFragment(P.code);
			node.appendChild(frag);
		}
	});

	return (
		<Switch>
			<Match when={P.type == 'iframe'}>
				<iframe class={css(iframeStyle(P.height),P.styling.css)} src={P.url} frameborder='0' marginheight='0' marginwidth='0'>Loading...</iframe>	
			</Match>
			<Match when={true}>
				<div class={css(P.styling.css)} ref={node} />
			</Match>
		</Switch>
	);
}

